import {
    NumberInput,
    NumberInputBaseProps,
} from "@impero-com/common/components/form/fields/numberInput";
import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";
import { z } from "zod";

export interface RHFNumberInputProps<TFieldValues extends FieldValues>
    extends NumberInputBaseProps, BaseRHFWidgetProps<TFieldValues, number> {
    schema: z.ZodNumber;
}

export function RHFNumberInput<TFieldValues extends FieldValues>({
    name,
    control,
    schema,
    className,
    label,
    disabled,
    placeholder,
    styleVariant,
    step,
    autoFocus,
    addonAfter,
    addonBefore,
    precision,
}: RHFNumberInputProps<TFieldValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    const min = schema.minValue;
    const max = schema.maxValue;
    const required = !schema.isOptional();
    const maybeIntPrecision = schema.isInt ? 0 : precision;

    return (
        <NumberInput
            value={field.value}
            fieldRef={field.ref}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
            onChange={field.onChange}
            min={min ?? undefined}
            max={max ?? undefined}
            required={required}
            precision={maybeIntPrecision}
            className={className}
            label={label}
            disabled={field.disabled}
            placeholder={placeholder}
            styleVariant={styleVariant}
            step={step}
            autoFocus={autoFocus}
            addonBefore={addonBefore}
            addonAfter={addonAfter}
        />
    );
}
